---
title: Log a Catch in Under 60 Seconds
description: A quick, calm Roddo logging flow that keeps you consistent without killing the vibe.
---

# Log a Catch in Under 60 Seconds

You don’t need a perfect log.
You need a *repeatable* one.

Here’s a clean 60-second Roddo flow.

## The 60-second checklist
1) **Where** (water type + general spot)  
2) **When** (time window)  
3) **What** (bait/lure)  
4) **How** (slow / fast / bottom / suspended)  
5) **Result** (caught / missed / nothing)  
6) **One line:** “what mattered?”

## Example (short + strong)
“Evening, calm pond edge. Small jig slow. One bite. Next time: same spot earlier.”

That’s enough to learn.

### Keep learning
- [What to log (and what to skip)](/learn/app/what-to-log)
- [A simple “what mattered” reflection](/learn/app/what-mattered)
- [Roddo Learn hub](/learn)
